var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useState } from "react";
import Draggable from "react-draggable";
import OutsideClickHandler from "react-outside-click-handler";
import { captureAddToWatchlistAnalytics } from "src/utils/analytics";
import { adddToWatchlist, getWatchlist, getWatchlistList, } from "../../apis/dashboard";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { closeAddToWatchlistModal, onModalOpenClose, } from "../../redux/reducers/modals";
import { filterUserWatchList, getEnvironmentVariableOrEmpty, } from "../../utils/methods";
import { ToastUtils } from "../../utils/toast-utils";
import styles from "./add-to-watchlist.module.scss";
import WatchlistItem from "./watchlist-item";
const { REACT_APP_URL_ASSET_BASE_PATH } = process.env;
const componentName = "watchlistModal";
const AddToWatchlist = () => {
    const [watchlistNames, setWatchlistNames] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const [whishlisted, setWishlisted] = useState([]);
    const dispatch = useAppDispatch();
    const isAddToWatchlistOpen = useAppSelector((state) => state.modals.isAddToWatchlistOpen);
    const addToWatchlistPayload = useAppSelector((state) => state.modals.addToWatchlistPayload);
    const onOutsideClick = () => {
        dispatch(closeAddToWatchlistModal());
        dispatch(onModalOpenClose({ componentName: "watchlistModal", currState: "close" }));
    };
    const fetchWatchlistNames = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const wlResp = yield getWatchlistList();
            const names = wlResp.data.body.MWName;
            setWatchlistNames(filterUserWatchList(names));
        }
        catch (err) {
            console.error(err);
        }
    }), []);
    const fetchWishlistsData = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const promises = watchlistNames.map((wl) => {
                return getWatchlist(wl.MwatchName);
            });
            const results = yield Promise.all(promises);
            const presentList = [];
            results.map((wlResp) => {
                const wlData = wlResp.data.Data;
                const MarketWatchName = wlResp.data.MarketWatchName;
                wlData.map((wl) => {
                    if (wl.ScripCode == (addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.ScripCode)) {
                        presentList.push(MarketWatchName);
                        return;
                    }
                });
            });
            setWishlisted(presentList);
        }
        catch (err) {
            console.error(err);
        }
    }), [watchlistNames, addToWatchlistPayload]);
    useEffect(() => {
        if (addToWatchlistPayload) {
            fetchWatchlistNames();
        }
        else {
            setSelectedItems({});
            setWishlisted([]);
        }
    }, [addToWatchlistPayload]);
    useEffect(() => {
        if (!isEmpty(watchlistNames)) {
            fetchWishlistsData();
        }
    }, [watchlistNames]);
    useEffect(() => {
        dispatch(onModalOpenClose({ componentName: "watchlistModal", currState: "open" }));
        return () => {
            dispatch(onModalOpenClose({
                componentName: "watchlistModal",
                currState: "close",
            }));
        };
    }, []);
    const onToggle = useCallback((isChecked, name) => {
        const map = Object.assign({}, selectedItems);
        if (isChecked) {
            map[name] = isChecked;
        }
        else {
            if (map[name]) {
                delete map[name];
            }
        }
        setSelectedItems(map);
    }, [selectedItems]);
    const addStockToWatchlist = useCallback((name) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const payload = {
                Exch: addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.Exch,
                ExchType: addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.ExchType,
                ScripCode: addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.ScripCode,
                watchlistName: name,
            };
            const resp = yield adddToWatchlist(payload);
            // captureAddToWatchlistAnalytics(
            //   true,
            //   addToWatchlistPayload?.name !== undefined
            //     ? addToWatchlistPayload.name
            //     : ""
            // );
            ToastUtils.success(resp.data.body.Message);
            return resp;
        }
        catch (err) {
            captureAddToWatchlistAnalytics(false, (addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.name) !== undefined
                ? addToWatchlistPayload.name
                : "");
            ToastUtils.error("Something went wrong");
            return err;
        }
    }), [addToWatchlistPayload]);
    const onAdd = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (Object.keys(selectedItems).length == 0) {
            ToastUtils.info("Please select at least one");
            return;
        }
        const promises = Object.keys(selectedItems).map((name) => {
            return addStockToWatchlist(name);
        });
        try {
            yield Promise.all(promises);
            captureAddToWatchlistAnalytics(true, `${addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.name}`);
            dispatch(closeAddToWatchlistModal());
            dispatch(onModalOpenClose({
                componentName: "watchlistModal",
                currState: "close",
            }));
            setSelectedItems({});
        }
        catch (err) {
            console.error(err);
            captureAddToWatchlistAnalytics(false, `${addToWatchlistPayload === null || addToWatchlistPayload === void 0 ? void 0 : addToWatchlistPayload.name}`);
            // alert("Something went wrong");
        }
    }), [addStockToWatchlist, dispatch, selectedItems]);
    if (!isAddToWatchlistOpen) {
        return null;
    }
    return (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: onOutsideClick }, { children: _jsx(Draggable, Object.assign({ handle: "#handle" }, { children: _jsxs("div", Object.assign({ className: styles.container, id: "handle" }, { children: [_jsxs("div", Object.assign({ className: styles.header }, { children: [_jsx("span", Object.assign({ className: `${styles.addWatchListText} mediumWeight` }, { children: "Add To Watchlist" })), _jsx("span", Object.assign({ className: `${styles.imageRight} pointer` }, { children: _jsx("img", { src: getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                                        "/fno/assets/svgs/close_icon.svg", alt: "Close-icon", onClick: () => {
                                        dispatch(closeAddToWatchlistModal());
                                        dispatch(onModalOpenClose({
                                            componentName: "watchlistModal",
                                            currState: "close",
                                        }));
                                    } }) }))] })), _jsxs("div", Object.assign({ className: styles.content }, { children: [watchlistNames.map((wl) => {
                                const isChecked = whishlisted.includes(wl.MwatchName);
                                const isSelected = selectedItems[wl.MwatchName] || isChecked;
                                const isDisabled = wl.ScripCount == 50 || isChecked;
                                return (_jsx("div", Object.assign({ className: `${styles.wlItem} justify-content-between` }, { children: _jsx(WatchlistItem, { watchlistItem: wl, disabled: isDisabled, isChecked: isSelected, onToggle: onToggle, scripCount: wl.ScripCount }) }), wl.MwatchName));
                            }), _jsx("div", Object.assign({ className: "d-flex justify-content-center" }, { children: _jsx("button", Object.assign({ className: "btnType1 my-3 px-4", onClick: onAdd, disabled: watchlistNames.length == whishlisted.length }, { children: "Add" })) }))] }))] })) })) })));
};
export default AddToWatchlist;
